(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["astra-product-sizes"] && !Shopify.designMode) return;
  try {
    
  function initAstraScenes(root = document) {
    root.querySelectorAll('[data-astra-scene]:not([data-prepared])').forEach(scene => {
      scene.dataset.prepared = 'true';
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        const source = new Image();
        source.crossOrigin = 'anonymous';
        source.onload = () => {
          try {
            const canvas = document.createElement('canvas');
            canvas.width = source.naturalWidth;
            canvas.height = source.naturalHeight;
            const context = canvas.getContext('2d');
            context.drawImage(source, 0, 0);
            const { data } = context.getImageData(0, 0, canvas.width, canvas.height);
            let minX = canvas.width, minY = canvas.height, maxX = 0, maxY = 0, transparent = 0;
            for (let y = 0; y < canvas.height; y++) {
              for (let x = 0; x < canvas.width; x++) {
                const alpha = data[(y * canvas.width + x) * 4 + 3];
                if (alpha < 8) transparent++;
                if (alpha > 8) { minX = Math.min(minX, x); minY = Math.min(minY, y); maxX = Math.max(maxX, x); maxY = Math.max(maxY, y); }
              }
            }
            if (transparent < canvas.width * canvas.height * .12 || maxX <= minX || maxY <= minY) return;
            const width = maxX-minX+1, height = maxY-minY+1;
            const trimmed = document.createElement('canvas');
            trimmed.width = width; trimmed.height = height;
            trimmed.getContext('2d').drawImage(source,minX,minY,width,height,0,0,width,height);
            const url = trimmed.toDataURL('image/png');
            scene.style.setProperty('--ratio', width / height);
            const busts = [...scene.querySelectorAll('.astra-lab-scene__bust')];
            const scales = busts.map(bust => Number(bust.style.getPropertyValue('--scale')));
            const gap = .025;
            const available = .75;
            const ratio = width / height;
            const maxHeight = Math.min(.586, (available - gap * (busts.length - 1)) * 1.5 / (ratio * scales.reduce((sum, scale) => sum + scale, 0)));
            const widths = scales.map(scale => scale * maxHeight * ratio / 1.5);
            const totalWidth = widths.reduce((sum, value) => sum + value, 0) + gap * (busts.length - 1);
            let cursor = .19 + (available - totalWidth) / 2;
            busts.forEach((bust, index) => {
              bust.style.height = `${scales[index] * maxHeight * 100}%`;
              bust.style.setProperty('--left', `${(cursor + widths[index] / 2) * 100}%`);
              cursor += widths[index] + gap;
            });
            scene.querySelectorAll('[data-scene-product]').forEach(img => { img.src = url; });
            scene.hidden = false;
          } catch { scene.hidden = true; }
        };
        source.src = scene.dataset.source;
      }, { rootMargin:'500px' });
      observer.observe(scene.closest('[data-astra-sizes]'));
    });
  }
  initAstraScenes();
  document.addEventListener('shopify:section:load', event => initAstraScenes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbv-campaign-hero"] && !Shopify.designMode) return;
  try {
    
  function initializeTbvHeroCarousel(carousel) {
    if (carousel.dataset.initialized === 'true') return;
    carousel.dataset.initialized = 'true';

    const slides = Array.from(carousel.querySelectorAll('[data-tbv-hero-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-tbv-hero-dot]'));
    const previousButton = carousel.querySelector('[data-tbv-hero-previous]');
    const nextButton = carousel.querySelector('[data-tbv-hero-next]');
    const toggleButton = carousel.querySelector('[data-tbv-hero-toggle]');
    const toggleIcon = carousel.querySelector('[data-tbv-hero-toggle-icon]');
    const status = carousel.querySelector('[data-tbv-hero-status]');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoplayEnabled = carousel.dataset.autoplay === 'true' && !prefersReducedMotion.matches;
    const interval = Math.max(Number(carousel.dataset.interval) || 7000, 4000);
    let activeIndex = 0;
    let timer;
    let pausedByUser = false;
    let pointerStartX = null;

    function announce(index) {
      if (!status) return;
      const name = slides[index].dataset.slideName;
      status.textContent = name || `${index + 1} / ${slides.length}`;
    }

    function showSlide(index, shouldAnnounce = true) {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });
      if (shouldAnnounce) announce(activeIndex);
    }

    function stopTimer() {
      window.clearInterval(timer);
      timer = undefined;
    }

    function startTimer() {
      stopTimer();
      if (!autoplayEnabled || pausedByUser || document.hidden) return;
      timer = window.setInterval(() => showSlide(activeIndex + 1, false), interval);
    }

    function setPausedState(paused) {
      pausedByUser = paused;
      if (toggleButton) {
        const pauseLabel = toggleButton.dataset.pauseLabel;
        const playLabel = toggleButton.dataset.playLabel;
        toggleButton.setAttribute('aria-pressed', String(paused));
        toggleButton.setAttribute('aria-label', paused ? playLabel : pauseLabel);
      }
      if (toggleIcon) toggleIcon.setAttribute('data-paused', String(paused));
      if (paused) stopTimer();
      else startTimer();
    }

    previousButton?.addEventListener('click', () => {
      showSlide(activeIndex - 1);
      startTimer();
    });
    nextButton?.addEventListener('click', () => {
      showSlide(activeIndex + 1);
      startTimer();
    });
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        showSlide(Number(dot.dataset.tbvHeroDot));
        startTimer();
      });
    });
    toggleButton?.addEventListener('click', () => setPausedState(!pausedByUser));

    carousel.addEventListener('pointerdown', (event) => {
      pointerStartX = event.clientX;
    });
    carousel.addEventListener('pointerup', (event) => {
      if (pointerStartX === null) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) < 50) return;
      showSlide(activeIndex + (distance < 0 ? 1 : -1));
      startTimer();
    });
    carousel.addEventListener('mouseenter', stopTimer);
    carousel.addEventListener('mouseleave', startTimer);
    carousel.addEventListener('focusin', stopTimer);
    carousel.addEventListener('focusout', startTimer);
    document.addEventListener('visibilitychange', startTimer);
    prefersReducedMotion.addEventListener('change', () => {
      if (prefersReducedMotion.matches) stopTimer();
      else startTimer();
    });

    showSlide(0, false);
    startTimer();
  }

  function initializeTbvHeroCarousels(root = document) {
    root.querySelectorAll('[data-tbv-hero-carousel]').forEach(initializeTbvHeroCarousel);
  }

  initializeTbvHeroCarousels();
  document.addEventListener('shopify:section:load', (event) => initializeTbvHeroCarousels(event.target));

  } catch(e) { console.error(e); }
})();
})();
